import React from "react";
import Routes from "./Routes";
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import AuthDebugPanel from './components/AuthDebugPanel';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes />
        {import.meta.env.DEV && <AuthDebugPanel />}
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
